import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "common-dialog-content" }
const _hoisted_2 = {
  key: 0,
  class: "common-dialog-header"
}
const _hoisted_3 = {
  key: 1,
  class: "common-dialog-title"
}
const _hoisted_4 = {
  key: 2,
  class: "text-rt mt_10 commit"
}

import { ref, useSlots, useAttrs } from 'vue'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'width', 'title', 'className', 'footer', 'closeOnClickModal', 'loading', 'disabled', 'noHeader', 'hideCancelBtn', 'okText', 'hiddenClose', 'top', 'zIndex', 'cancelText'],
  emits: ['update:visible', 'ok', 'cancel', 'opened'],
  setup(__props, { emit: emits }) {

const props = __props

const selfprop = useAttrs()

const slots = useSlots()
const cancel = () => {
  emits('cancel')
}
const ok = () => {
  emits('ok')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, _mergeProps({ "z-index": __props.zIndex }, _unref(selfprop), {
    "model-value": __props.visible,
    "show-close": false,
    width: __props.width,
    "destroy-on-close": "",
    "before-close": cancel,
    onCancel: cancel,
    "custom-class": __props.className + ' common-dialog',
    "close-on-click-modal": __props.closeOnClickModal,
    "append-to-body": true,
    top: __props.top,
    onOpened: _cache[0] || (_cache[0] = ($event: any) => (emits('opened'))),
    "close-on-press-escape": __props.closeOnClickModal
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!__props.noHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_unref(slots).header)
                ? _renderSlot(_ctx.$slots, "header", { key: 0 })
                : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1))
            ]))
          : _createCommentVNode("", true),
        (!__props.hiddenClose)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "iconfont icon-guanbi2",
              onClick: cancel
            }))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default"),
        (__props.footer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "footer-slot"),
              (!__props.hideCancelBtn)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "default",
                    onClick: cancel,
                    class: "footer-btn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.cancelText ? __props.cancelText :
          _unref(t)('取消')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: ok,
                class: "footer-btn",
                loading: __props.loading,
                disabled: __props.disabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.okText ?
          __props.okText :
          _unref(t)('确定')), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 16, ["z-index", "model-value", "width", "custom-class", "close-on-click-modal", "top", "close-on-press-escape"]))
}
}

})